module.exports = __webpack_public_path__ + "img/notesattachments-ar.9f129ee5.png";